import React from "react";

function StatCard({
    title,
    value,
    subtitle,
    icon,
    trend,
    trendValue,
    className = "",
}) {
    return (
        <div
            className={`bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 ${className}`}
        >
            <div className="flex items-center justify-between mb-2">
                <h3 className="text-white/60">{title}</h3>
                {icon && <div className="text-blue-400">{icon}</div>}
            </div>
            <div className="flex items-end justify-between">
                <div className="text-3xl font-bold">{value}</div>
                {trend && (
                    <div
                        className={`flex items-center ${
                            trend === "up"
                                ? "text-green-400"
                                : trend === "down"
                                ? "text-red-400"
                                : "text-gray-400"
                        }`}
                    >
                        {trend === "up" && (
                            <svg
                                className="w-4 h-4 mr-1"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M5 10l7-7m0 0l7 7m-7-7v18"
                                />
                            </svg>
                        )}
                        {trend === "down" && (
                            <svg
                                className="w-4 h-4 mr-1"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M19 14l-7 7m0 0l-7-7m7 7V3"
                                />
                            </svg>
                        )}
                        {trendValue}
                    </div>
                )}
            </div>
            {subtitle && (
                <p className="text-white/40 text-sm mt-2">{subtitle}</p>
            )}
        </div>
    );
}

export default StatCard;
